module.exports = __webpack_public_path__ + "img/directions.2064d2bc.svg";